import { action } from 'satcheljs/lib/legacy';
export default action('setIsDirty')(function setIsDirty(viewState) {
    viewState.isDirty = true;
});
//# sourceMappingURL=setIsDirty.js.map